export enum DomainTypeEnum {
  Travel = 'etravel',
  EventTicketProtection = 'eticket',
  EventRegistration = 'eregistration',
  Session = 'session',
  Season = 'season'
}
